export const fetchAPI = (date) => {
    // Mocking available times for the given date
    const availableTimes = ["18:00", "19:00", "20:00", "21:00", "22:00"];
    return availableTimes;
};

export const submitAPI = (formData) => {
    // Simulate successful form submission
    return true;
};
